import React from "react"
import { Link } from "react-router-dom"
import {
  Card,
  CardBody,
  CardFooter,
  Col,
  UncontrolledTooltip,
} from "reactstrap"
import images from "assets/images"

const UserCard = (props: any) => {
  const { user, onEdit, canEdit, onManage } = props

  return (
    <React.Fragment>
      <Col xl="3" lg="4" sm="6">
        <Card className="mw-user-card text-center">
          <CardBody>
            <span className="mw-user-av">
              {(user.name || "?").charAt(0).toUpperCase()}
            </span>
            <h5 className="mw-user-name">{user.name}</h5>
            <p className="mw-user-email">{user.email}</p>
            <span className="mw-role-badge">{user.role}</span>
          </CardBody>
          {(canEdit || onManage) && (
            <CardFooter className="bg-transparent border-top d-flex justify-content-center" style={{ gap: 8 }}>
              {canEdit && (
                <button
                  type="button"
                  className="btn btn-sm mw-user-edit"
                  onClick={e => onEdit()}
                >
                  <i className="bx bx-edit-alt me-1" />
                  Edit
                </button>
              )}
              {onManage && (
                <button
                  type="button"
                  className="btn btn-sm mw-user-edit"
                  onClick={e => onManage()}
                >
                  <i className="bx bx-key me-1" />
                  Manage Access
                </button>
              )}
            </CardFooter>
          )}
        </Card>
      </Col>
    </React.Fragment>
  )
}

export default UserCard
